/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcRegistrationV1ProfileEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_REGISTRATION_V1_PROFILE_EVENT_ENTITY_NAME = 'ixc.registration.v1.ProfileEvent';
export const ixcRegistrationV1ProfileEventEntity = new schema.Entity<IxcRegistrationV1ProfileEvent>(IXC_REGISTRATION_V1_PROFILE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcRegistrationV1ProfileEvent) => `${entity.metadata?.eventId}` });

